import sysMsgs from '@/helpers/system.message'
import apiPayments from '@/services/finance.services'

export default {
  name: "ClientReport",
  data() {
    return {
      loading: false,
      controller: {
        title: "Finanzas / Reporte Clientes",
        mainRouter: "/finanzas/reporte-clientes"        
      },
      paginate: ['excel.data'],
      data: null,
      dealer:{
        _data: null,
        options: {
          selectData: true,
          active: true
        }
      },
      table:{
        fields: {
          "Código de Cliente" : "id",
          "Rut" : "rut",
          "Nombre Legal" : "legal_name",
          "Nombre Fantasia" : "fantasy_name",
          "Dirección" : "address",
          "Comuna" : "comuna",
          "Plan" : "plan_name",
          "Avisos Contratados" : "plan_quantity",
          "Avisos activos" : "adverts",
          "Id Producto" : "productId",
          "Producto" : "productName",
          "Fecha Inicio" : "productStartDate",
          "Fecha Fin" : "productEndDate",
          "Bloqueado" : "locked",
          "Avisos Bloqueados" : "adverts_locked",
          "Historial": "history"
        }
      },
      excel: {
        data: [],
        name: null,
        worksheet: "Clientes",
        fields: {
          "Código de Cliente" : "id",
          "Rut" : "rut",
          "Nombre Legal" : "legal_name",
          "Nombre Fantasia" : "fantasy_name",
          "Dirección" : "address",
          "Comuna" : "comuna",
          "Plan" : "plan_name",
          "Avisos Contratados" : "plan_quantity",
          "Avisos activos" : "adverts",
          "Id Producto" : "productId",
          "Producto" : "productName",
          "Fecha Inicio" : "productStartDate",
          "Fecha Fin" : "productEndDate",
          "Bloqueado" : "locked",
          "Avisos Bloqueados" : "adverts_locked"
        }
      }
    };
  },
  watch:{
    'dealer._data': {
      deep: true,
      handler() {
        this.excel.data = [];
        this.paginate['excel.data'].page = 0;
      }
    }
  },
  methods:{
    getInfo()
    {
      let id = this.dealer._data ? this.dealer._data.cod_cliente : "";
      this.loading = true;
      apiPayments.getClientReport(id).then(response => {
        let fileDate = new Date();
        this.excel.name = `clientes_${fileDate.getHours().toString()}${fileDate.getMinutes().toString()}${fileDate.getSeconds().toString()}${fileDate.getMilliseconds().toString()}.xls`;
        this.excel.data = response.data;
        this.data = response.data;
      }).catch(error => {
        sysMsgs.getResponseMessage(error.response);      
      }).finally(f => {
        this.loading = false;
      });
    },
    getFieldName(field)
    {
      let _self = this;
      let caption = null;
      Object.keys(this.table.fields).map(function(objectKey, index) {
        if(_self.table.fields[objectKey] == field)
          caption = objectKey;
          return false;
      })
      return caption ? caption : field;
    }
  },
  created(){
    
  }
};